/**
 * Return a string with special characters replaced
 * @param inputString string to be sanitized
 */
export function replaceSpecialCharacters(inputString) {
    return inputString
        .replace(/[àáâãåæāăąǻǽάαаạảấầẩẫậắằẳẵặ]/g, 'a')
        .replace(/[çćĉċčс]/g, 'c')
        .replace(/[ďđ]/g, 'd')
        .replace(/[èéêëēĕėęěəέεеẹẻẽếềểễ]/g, 'e')
        .replace(/[ĝğġģ]/g, 'g')
        .replace(/[ĥħ]/g, 'h')
        .replace(/[ĩīĭįıĳ]/g, 'i')
        .replace(/[ĵ]/g, 'j')
        .replace(/[ķĸκ]/g, 'k')
        .replace(/[ĺļľŀłλ]/g, 'l')
        .replace(/[ñńņňŉŋ]/g, 'n')
        .replace(/[ðòóôõøōŏőơǒǿοọỏốồổỗộớờởỡợ]/g, 'o')
        .replace(/[ŕŗř]/g, 'r')
        .replace(/[śŝşšѕ]/g, 's')
        .replace(/[ţťŧ]/g, 't')
        .replace(/[ũūŭůűųưǔǖǘǚǜΰцụủứừửự]/g, 'u')
        .replace(/[ŵẁẃẅ]/g, 'w')
        .replace(/[ŷуүỳỵỷỹ]/g, 'y')
        .replace(/[źżž]/g, 'z')
        .replace(/[ÀÁÂÃÅÆĀĂĄǺǼΆẠẢẤẦẨẪẬẮẰẲẴẶ]/g, 'A')
        .replace(/[ÇĆĈĊČ]/g, 'C')
        .replace(/[ÐĎ]/g, 'D')
        .replace(/[ÈÉÊËĒĔĖĘĚΈΕЁẸẺẼẾỀỂỄỆ]/g, 'E')
        .replace(/[ĜĞĠĢ]/g, 'G')
        .replace(/[ĤĦΗ]/g, 'H')
        .replace(/[ÌÍÎÏΐЇỈỊ]/g, 'I')
        .replace(/[Ĵ]/g, 'J')
        .replace(/[Ķ]/g, 'K')
        .replace(/[ĹĻĽĿŁ]/g, 'L')
        .replace(/[ŃŅŇŊΝИЙ]/g, 'N')
        .replace(/[ÒÓÔÕØŌŎŐƠǑǾΟОỌỎỐỒỔỖỘỚỜỞỠỢ]/g, 'O')
        .replace(/[ŔŖŘ]/g, 'R')
        .replace(/[ŚŜŞŠ]/g, 'S')
        .replace(/[ŢŤŦ]/g, 'T')
        .replace(/[ŨŪŬŮŰŲƯǓǕǗǙǛỤỦỨỪỬỮỰ]/g, 'U')
        .replace(/[ŴẀẂẄ]/g, 'W')
        .replace(/[ŶŸỲỴỶỸ]/g, 'Y')
        .replace(/[ŹŻŽ]/g, 'Z')
        .replace(/Ä/g, 'Ae')
        .replace(/Ö/g, 'Oe')
        .replace(/Ü/g, 'Ue')
        .replace(/ä/g, 'ae')
        .replace(/ö/g, 'oe')
        .replace(/ü/g, 'ue')
        .replace(/ß/g, 'ss');
}
export var Separators;
(function (Separators) {
    Separators["Dash"] = "-";
    Separators["Underscore"] = "_";
    Separators["None"] = "";
})(Separators || (Separators = {}));
/**
 * Return a string with a separator instead of spaces
 * @param inputString string to be sanitized
 * @param separator separator sequence to be applied, defaults to Separators.Dash
 */
export function replaceSpaces(inputString, separator = Separators.Dash) {
    return inputString.replace(/ /g, separator);
}
/**
 * Return a string with slashes replaced by the separator
 * This converts slashes in titles (e.g., "km/h" → "km-h", "2025/2026" → "2025-2026")
 * to prevent SEO indexing issues with slashes in URL paths
 * @param inputString string to be sanitized
 * @param separator separator sequence to be applied, defaults to Separators.Dash
 */
export function replaceSlashes(inputString, separator = Separators.Dash) {
    return inputString.replace(/\//g, separator);
}
/**
 * Return a string without consecutive separators
 * @param inputString string to be sanitized
 * @param separator separator sequence to be applied, defaults to Separators.Dash
 */
export function replaceConsecutiveSeparators(inputString, separator = Separators.Dash) {
    if (separator === Separators.None)
        return inputString;
    // eslint-disable-next-line @rushstack/security/no-unsafe-regexp
    const regex = new RegExp(`${separator}+`, 'g');
    return inputString.replace(regex, separator);
}
/**
 * Return a string without leading and trailing separators
 * Removes separator before and after slashes, at the beginning, and at the end of the string
 * @param inputString string to be sanitized
 * @param separator separator sequence to be applied, defaults to Separators.Dash
 */
export function removeLeadingAndTrailingSeparators(inputString, separator = Separators.Dash) {
    if (separator === Separators.None)
        return inputString;
    // eslint-disable-next-line @rushstack/security/no-unsafe-regexp
    const afterSlashRegex = new RegExp(`/${separator}+`, 'g');
    // eslint-disable-next-line @rushstack/security/no-unsafe-regexp
    const beforeSlashRegex = new RegExp(`${separator}+/`, 'g');
    // eslint-disable-next-line @rushstack/security/no-unsafe-regexp
    const startOfStringRegex = new RegExp(`^${separator}+`, 'g');
    // eslint-disable-next-line @rushstack/security/no-unsafe-regexp
    const endOfStringRegex = new RegExp(`${separator}$`, 'g');
    return (inputString
        // removes separator at the beginning of the string
        .replace(startOfStringRegex, '')
        // removes separators after slashes with just slashes
        .replace(afterSlashRegex, '/')
        // removes separators before slashes with just slashes
        .replace(beforeSlashRegex, '/')
        // removes separator at the end of the string
        .replace(endOfStringRegex, ''));
}
/**
 * Return a string without characters that are not part of the set [a-z], [0-9], '-', '/'
 * @param inputString string to be sanitized
 * @param separator separator sequence to be applied, defaults to Separators.Dash
 * @param options optional settings such as preserveHyphens for page-tag style sanitization
 */
export function replaceNonAlphanumericCharacters(inputString, separator = Separators.Dash, options) {
    const extraAllowedChars = options?.preserveHyphens ? '-' : '';
    // eslint-disable-next-line @rushstack/security/no-unsafe-regexp
    const regex = new RegExp(`[^a-z0-9/${separator}${extraAllowedChars}]`, 'g');
    return inputString.replace(regex, separator);
}
/**
 * remove domain from inputString, return only URL path
 * @param inputString full URL (with or without protocol and credentials) or only path part of the URL
 */
export function getDomainFreePath(inputString) {
    const domainRegex = /^(?:https?:\/\/)?(?:[^@/\n]+@)?(?:www\.)?([^:/\n]+)?/;
    const domainMatch = inputString.match(domainRegex);
    if (domainMatch && domainMatch[1]) {
        const domain = domainMatch[1];
        const domainLength = domain.length;
        const pathStartIndex = inputString.indexOf(domain) + domainLength;
        return inputString.substring(pathStartIndex);
    }
    else {
        // If no domain found, return the original URL
        return inputString;
    }
}
/**
 * Return a lowercase string without special characters, spaces, consecutive separators, leading and trailing separators
 * @param inputString string to be sanitized
 * @param separator separator sequence to be applied, defaults to Separators.Dash
 * @param options optional settings such as preserveHyphens for page-tag style sanitization
 */
export function sanitizeString(inputString, separator = Separators.Dash, options) {
    let outputString = inputString;
    outputString = replaceSpecialCharacters(outputString);
    outputString = outputString.toLowerCase();
    outputString = replaceSpaces(outputString, separator);
    outputString = replaceNonAlphanumericCharacters(outputString, separator, options);
    outputString = replaceConsecutiveSeparators(outputString, separator);
    outputString = removeLeadingAndTrailingSeparators(outputString, separator);
    return outputString;
}
/**
 * Return a lowercase string without special characters, spaces, consecutive separators, leading and trailing separators
 * FOR URL GENERATION: Slashes in the input are converted to the separator (e.g., "km/h" → "km-h") for SEO compatibility
 * This ensures that content titles containing slashes generate proper URL slugs
 * Use this function explicitly when generating URL slugs for channels and articles (CTF-7050)
 * @param inputString string to be sanitized for URL
 * @param separator separator sequence to be applied, defaults to Separators.Dash
 */
export function sanitizeStringForUrl(inputString, separator = Separators.Dash) {
    let outputString = inputString;
    outputString = replaceSpecialCharacters(outputString);
    outputString = outputString.toLowerCase();
    outputString = replaceSpaces(outputString, separator);
    outputString = replaceSlashes(outputString, separator);
    outputString = replaceNonAlphanumericCharacters(outputString, separator);
    outputString = replaceConsecutiveSeparators(outputString, separator);
    outputString = removeLeadingAndTrailingSeparators(outputString, separator);
    return outputString;
}
/**
 * Return a string array sanitized array elements
 * @param inputString string array to be sanitized
 * @param separator separator sequence to be applied, defaults to Separators.Dash
 * @param options optional settings such as preserveHyphens for page-tag style sanitization
 */
export function sanitizeStringArray(inputArray, separator = Separators.Dash, options) {
    return inputArray.map((inputString) => sanitizeString(inputString, separator, options));
}
/**
 * Remove HTML Tags and quotation makrs from input string
 * @param inputString string to be sanitized
 */
export function removeHTMLTagsAndQuotationMarks(inputString) {
    const HTMLTagsRegex = new RegExp(/<[^>]*>/, 'g');
    const quotationMarksRegex = new RegExp(/['"]/, 'g');
    return inputString.replace(HTMLTagsRegex, '').replace(quotationMarksRegex, '');
}
/**
 * Normalizes strings for element tracking purposes:
 * - Lower case;
 * - Removes diacritics, with special handling for German umlauts and sharp S;
 * - Replaces all whitespace characters with hyphens;
 * - Removes all characters from a string except for word characters, hyphens, and plus signs;
 * - Removes leading/trailing hyphens and replace multiple hyphens with a single hyphen.
 *
 * @param {string} input string to normalize
 * @returns {string}  normalized string
 */
export function normalizeElementTrackingString(input) {
    return (input
        .toLowerCase()
        // umlauts map
        .replace(/ä/g, 'ae')
        .replace(/ö/g, 'oe')
        .replace(/ü/g, 'ue')
        .replace(/Ä/g, 'Ae')
        .replace(/Ö/g, 'Oe')
        .replace(/Ü/g, 'Ue')
        .replace(/ß/g, 'ss') // manually handle ß
        .normalize('NFD') // decompose accented characters into base + diacritics
        .replace(/[\u0300-\u036f]/g, '') // remove diacritics from other chars (é, ñ, etc.)
        .replace(/\s+/g, '-') // replace all whitespace characters with hyphens
        .replace(/[^\w-+]+/g, '') // remove all characters from a string except for word characters, hyphens, and plus signs
        .replace(/^-+|-+$|(-)+/g, '$1') // remove leading/trailing hyphens and replace multiple hyphens with a single hyphen
    );
}
//# sourceMappingURL=stringSanitizers.js.map